/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskCustomDetectionRule,
  RiskCustomDetectionRule$inboundSchema,
} from "./riskcustomdetectionrule.js";

export type ListCustomDetectionRulesResult = {
  /**
   * The list of custom detection rules.
   */
  rules: Array<RiskCustomDetectionRule>;
};

/** @internal */
export const ListCustomDetectionRulesResult$inboundSchema: z.ZodMiniType<
  ListCustomDetectionRulesResult,
  unknown
> = z.object({
  rules: z.array(RiskCustomDetectionRule$inboundSchema),
});

export function listCustomDetectionRulesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListCustomDetectionRulesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListCustomDetectionRulesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListCustomDetectionRulesResult' from JSON`,
  );
}
